import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { SubscribeWebPushEffects } from "./effects/subscribe-web-push.effects";

@NgModule({
    imports: [
        CommonModule,
        EffectsModule.forFeature([
            SubscribeWebPushEffects,
        ]),
    ],
    exports: [],
})
export class SharedServiceWorkerFeatureWebPushModule {}
